<template>
    <div class="vx-container vx-mx-auto vx-px-3 vx-pb-32 md:vx-px-8 2xl:vx-max-w-screen-xl vx-space-y-8">
        <div class="vx-flex vx-flex-col vx-gap-12 lg:vx-flex-row">
            <div class="vx-shrink-0 lg:vx-w-60">
                <analytics-outbound-messages-sidebar v-model="fetchParams"></analytics-outbound-messages-sidebar>
            </div>
            <div class="vx-w-full">
            </div>
        </div>
    </div>
</template>

<script setup>
import AnalyticsOutboundMessagesSidebar from './AnalyticsOutboundMessagesSidebar.vue';
import { ref } from 'vue';
import { controlDateRangeOptions } from '~/utils/analytics';

const fetchParams = ref({
    range: controlDateRangeOptions().find(option => option.value === 'last_30_days'),
    filters: {
        audience_types: [],
    }
});
</script>
